<app-header-tela [titulo]="'Detalhes Do Produto'" [exibirFechar]="true" (fechou)="fecheTela()" ></app-header-tela>

<div *ngIf="msgErroEstoque" class="alerta-estoque-topo shadow-sm">
  {{msgErroEstoque}}
</div>

<div class="k-i-loading ml-1 mr-1 centralizado" *ngIf="carregando"  ></div>

<div *ngIf="itemPedido && produto">
  <div>
    <div>
      <div class="mt-2">
        <div class="row">
          <div class="col-12" *ngIf="(imagens && imagens.length > 0)">
            <div class="row">
              <div class="col-auto" *ngIf="imagens.length > 1" style="padding-left: 2px; padding-right: 2px">
                <div style="text-align: center">
                  <ng-container *ngFor="let imagem of imagens; let i = index">
                      <img  class="img-pequena img-fluid rounded" (mouseover)="selecionou(i)" (touchend)="selecionou(i)" [class.selecionada]="i == selecionada" [src]="'https://fibo.promokit.com.br/images/empresa/' + imagens[i].linkImagem"/><br>
                  </ng-container>
                </div>
              </div>
              <div class="col">

                <div style="text-align: center;" >
                  <img  class="img img-fluid rounded" (click)="exibaFullScreen()" [src]="'https://fibo.promokit.com.br/images/empresa/' + imagens[selecionada].linkImagem"/>
                </div>

                <div  style="position: absolute;left: -1500px">
                  <ng-image-slider #nav    [images]="imagensSlider"  (imageClick)="abriuImagem($event)"   [autoSlide]="1" slideImage="1"></ng-image-slider>
                </div>

              </div>
            </div>

          </div>

          <div class="col-12"  [ngClass]="{'esgotado': produto.indisponivel}">
            <h4>{{produto.nome}}</h4>

            <p class="descricao" [innerHTML]="produto.descricao"></p>

            <app-tags-alimentar [tags]="produto.tags" [exibirLabel]="true" *ngIf="produto.tags?.length"></app-tags-alimentar>



            <h4 class="preco"    *ngIf="!produto.brinde">
              <!-- kit com quantidade escolhida: o preço vale pela referência, nunca "a partir de" -->
              <ng-container *ngIf="produto.tipo === 'kit' && produto.configKit?.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'; else precoPadrao">
                {{ produto.preco | currency: 'BRL' }}
                <span class="text-muted font-13"> / {{ produto.configKit.qtdeUnidadesReferencia }} un.</span>
                <span class="text-muted font-13" *ngIf="produto.configKit.qtdeMinimaCompra !== produto.configKit.qtdeUnidadesReferencia"> · mín. {{ produto.configKit.qtdeMinimaCompra }} un.</span>
              </ng-container>
              <ng-template #precoPadrao>
                <span *ngIf="produto.valorMinimo" class="text-muted font-14  ">A partir de</span>
              <ng-container *ngIf="!produto.precoInical">

                {{(produto.valorMinimo ? produto.valorMinimo : produto.preco) | currency: 'BRL'}}

                <span class=" text-muted font-13" *ngIf="exibirUnidade()"> / kg </span>
              </ng-container>
              <ng-container *ngIf="produto.precoInical">
                {{ produto.precoInical | currency: 'BRL'}} / {{produto.valorInicial}} {{produto.unidadeMedida.sigla}}
              </ng-container>
              </ng-template>

              </h4>
            <h4 class="preco"  *ngIf="produto.brinde" >
               {{produto.valorResgate}} {{produto.acumulo}}
            </h4>


            <h4 class="preco antigo"  *ngIf="produto.precoAntigo">
                {{(produto.precoAntigo) | currency: 'BRL'}}
              </h4>
              <div class="preco-atacado-card" *ngIf="produto.precoAtacado && produto.quantidadeMinimaAtacado">
                <span class="preco-atacado-card__label"><i class="fas fa-fire"></i></span>
                <span class="preco-atacado-card__rule">Leve {{produto.quantidadeMinimaAtacado}}+</span>
                <strong>{{produto.precoAtacado | currency:'BRL'}}</strong>
                <span class="preco-atacado-card__suffix">cada</span>
                <span class="preco-atacado-card__saving" *ngIf="economiaAtacadoProduto() > 0">
                  Economizando {{economiaAtacadoProduto() | currency:'BRL'}}
                </span>
                <div class="preco-atacado-card__actions" *ngIf="!exibirUnidade() && !produto.indisponivel">
                  <button type="button" class="preco-atacado-card__button"
                          *ngIf="deveExibirBotaoSelecionarAtacado()"
                          [disabled]="atacadoProdutoJaSelecionado()"
                          (click)="selecionarQuantidadeAtacado()">
                    Selecionar {{produto.quantidadeMinimaAtacado}} unidades
                  </button>

                  <button type="button" class="preco-atacado-card__button preco-atacado-card__button--outline"
                          (click)="informarNovaQtde()">
                    Alterar Quantidade
                  </button>

                </div>
              </div>
              <i *ngIf="produto.qtdMaxima"><label class="text-muted" style="font-size: 10px">*Até {{produto.qtdMaxima}} por pedido&nbsp;&nbsp;</label></i>
            <ng-container *ngIf="!produto.indisponivel">
                <button class="btn btn-blue mt-2"  *ngIf="exibirUnidade()" (click)="informarPeso()">
                  ({{itemPedido.qtde | number:'1.0-2'}}{{itemPedido.produto.unidadeMedida.sigla}}) Alterar o peso</button>

                <button class="btn btn-blue mt-0 btn-sm"  *ngIf="!exibirUnidade() && !(produto.precoAtacado && produto.quantidadeMinimaAtacado)" (click)="informarNovaQtde()" [hidden]="exibirComboSelecao">
                  Alterar Quantidade</button>
            </ng-container>

            <ng-container *ngIf="produto?.estoque?.quantidade != null">
              <div class="disponibilidade-box mt-3" [ngClass]="{'alta-demanda': produto.estoque.altaDemanda}">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <div class="d-flex align-items-center">
                    <div class="icon mr-2" [ngClass]="{'text-danger': produto.estoque.altaDemanda}">
                      <i class="fas fa-exclamation-circle" *ngIf="produto.estoque.altaDemanda"></i>
                      <i class="fas fa-box-open" *ngIf="!produto.estoque.altaDemanda"></i>
                    </div>
                    <div>
                      <div class="disponibilidade-title" *ngIf="produto.estoque.altaDemanda">Alta demanda!</div>
                      <div class="disponibilidade-title" *ngIf="!produto.estoque.altaDemanda">DISPONIBILIDADE</div>
                    </div>
                  </div>

                  <div class="disponibilidade-badge" *ngIf="produto.estoque.quantidade">
                     <span *ngIf="produto.estoque.altaDemanda">APENAS</span>
                     {{ produto.estoque.quantidade }} UN.
                  </div>
                   <div class="disponibilidade-text text-danger" *ngIf="!produto.estoque.quantidade">
                     Esgotado
                  </div>
                </div>
                <div class="disponibilidade-progress">
                  <div class="bar"
                       [style.width.%]="
                         produto.estoque.quantidade > 0
                           ? (
                               produto.estoque.quantidade
                               / produto.estoque.total
                             ) * 100
                           : 0">
                  </div>
                </div>
              </div>
            </ng-container>

            <h5 *ngIf="produto.indisponivel" class="text-danger">Indisponível!</h5>
        </div>
      </div>
    </div>


      <app-kit-montagem *ngIf="produto.tipo === 'kit'" [item]="itemPedido"></app-kit-montagem>
      <ng-container *ngIf="produto.tamanhos && produto.tipo !== 'kit'">

        <app-adicionais-customizados #adicionaisCustomizados [itemPedido]="itemPedido" (alterouTamanho)="onAlterouTamanho($event)" >

        </app-adicionais-customizados>

      </ng-container>

      <div [hidden]="campoAdicional.tipo === 'componente-kit' || produto.tipo === 'kit' && campoAdicional.id === produto.configKit?.adicionalSaboresId" *ngFor="let campoAdicional of produto.camposAdicionais;  " id="adicional{{campoAdicional.posicao}}">
        <app-site-campo-adicional #adicionalComponent [id]="'adicional_' + campoAdicional.id" [campoAdicional]="campoAdicional" [produto]="produto"
                                  [itemPedido]="itemPedido" [posicao]="campoAdicional.posicao"
               (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"  (onMarcouOpcao)="escolheuNovaOpcao($event)" ></app-site-campo-adicional>
      </div>

      <ng-container *ngFor="let sabor of itemPedido.sabores">
        <ng-container *ngIf="sabor.produto !== produto.id">
          <div *ngFor="let adicionalSabor of sabor.camposAdicionais; ">

            <app-site-campo-adicional #adicionalComponent class="campo-adicional" [campoAdicional]="adicionalSabor" [produto]="sabor"
                                      [itemPedido]="itemPedido" [posicao]="adicionalSabor.posicao" [exibirSabor]="true" [tamanhoSabor]="sabor.produtoTamanho"
                                      (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"  (onMarcouOpcao)="escolheuNovaOpcao($event)" >

            </app-site-campo-adicional>
          </div>
        </ng-container>
      </ng-container>

      <div class="mt-2">
      <div class="mt-3"></div>
      <div class="form-group mb-3">
        <label for="observacao"><i class="fas fa-comment-dots"></i> Alguma Observação?</label>
        <textarea type="text" class="form-control" autocomplete="off" maxlength="255"
               id="observacao" name="observacao" [(ngModel)]="itemPedido.observacao" #observacao="ngModel"
               placeholder="Inclua uma observação sobre o pedido." value="" required>
        </textarea>

          <div class="invalid-feedback">
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-site-adicionar-produto #siteAdicionarProduto  (onInformarPeso)="informarPeso()" (onErroEstoque)="exibirErroEstoque($event)"
     [itemPedido]="itemPedido" [pedido]="pedido" [indiceItem]="indiceItem" [window]="window"  >

  </app-site-adicionar-produto>


  <kendo-window [width]="300" title="Alterar peso"  [left]="leftWindow" [top]="topWindow"
                *ngIf="alterarPeso" (close)="fecheModal(false)" #alterarPesoModal>
    <p class="alert alert-danger mt-1 mb-2" *ngIf="msgErroAlterarPeso">
      {{msgErroAlterarPeso}}
    </p>

    <input #inputNovoPeso  name="novoPeso" type="text"   class="form-control troco" step="{{obtenhaIncremento()}}"
           type="text" inputmode="decimal" appSelecionarNoFoco
           currencyMask [options]="{ prefix: '', suffix: ' ' + this.produto.unidadeMedida.sigla, precision:
            this.produto.unidadeMedida.sigla === 'g' ? 0 : 3  , thousands: '', decimal: ',', align: 'left',
            allowNegative: false }"
           [(ngModel)]="novoPeso"  />

    <div class="clearfix mt-2"></div>
    <button type="button" class="btn btn-success mr-2"  (click)="salveNovoPeso()"  >Salvar</button>
    <button type="button" class="btn btn-light  " data-dismiss="modal"  (click)="fecheModal(false)">Cancelar</button>

  </kendo-window>

  <kendo-window [width]="300" title="Alterar Quantidade"  [left]="leftWindow" [top]="topWindow"
                *ngIf="alterarQtde" (close)="fecheModal(false)" #alterarPesoModal>
    <p class="alert alert-danger mt-1 mb-2" *ngIf="msgErroAlterarQtde">
      {{msgErroAlterarQtde}}
    </p>

    <ng-container *ngIf="!exibirComboSelecao">
      <input #inputNovaQtde  name="novoPeso" type="text"   class="form-control troco" step="1"
             type="text" inputmode="decimal" appSelecionarNoFoco
             currencyMask [options]="{ prefix: '', suffix: ' UN', precision: 0, thousands: '', decimal: ',', align: 'left',
            allowNegative: false }"
             [(ngModel)]="novaQtde"  />
    </ng-container>


    <ng-container *ngIf="!exibirComboSelecao">

    </ng-container>



    <div class="clearfix mt-2"></div>
    <button type="button" class="btn btn-success mr-2"  (click)="salveAltereQtde()"  >Salvar</button>
    <button type="button" class="btn btn-light  " data-dismiss="modal"  (click)="fecheModal()">Cancelar</button>

  </kendo-window>

</div>
